import { useState, useEffect } from 'react';

function useRemainingTime(futureDate) {
  const lang = localStorage.getItem('lang');

  function getRemainingTime() {
    const currentDate = new Date();
    const futureDateFormatted = new Date(futureDate);
    const difference = futureDateFormatted.getTime() - currentDate.getTime();
    if (difference < 0) {
      return '00:00:00';
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    if (days > 0) {
      let result = '';
      switch (days) {
        case 1:
          result = lang === 'en' ? `${days} day` : `يوم واحد`;
          break;
        case 2:
          result = lang === 'en' ? `${days} days` : `يومين`;
          break;
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          result = lang === 'en' ? `${days} days` : `${days} أيام`;
          break;
        default:
          result = lang === 'en' ? `${days} days` : `${days} يوم`;
          break;
      }
      return result;
    }

    const hours = Math.floor(difference / (1000 * 60 * 60));
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);
    return `${hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }
  const [remainingTime, setRemainingTime] = useState(getRemainingTime());

  useEffect(() => {
    const interval = setInterval(() => {
      const timeValue = getRemainingTime();
      if (timeValue === '00:00:00') clearInterval(interval);
      else setRemainingTime(timeValue);
    }, 1000);
    return () => clearInterval(interval);
  }, [futureDate]);

  return remainingTime;
}

export default useRemainingTime;
